import React from 'react';
import { motion } from 'framer-motion';

const Section = ({ 
  children, 
  className = '', 
  id,
  background = 'white',
  padding = 'default',
  ...props 
}) => {
  const backgrounds = {
    white: 'bg-white',
    gray: 'bg-neutral-50',
    dark: 'bg-neutral-900 text-white',
  };

  const paddings = {
    none: '',
    sm: 'py-8',
    default: 'py-16',
    lg: 'py-24',
  };

  const classes = `${backgrounds[background]} ${paddings[padding]} ${className}`;

  return (
    <section id={id} className={classes} {...props}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {children}
      </div>
    </section>
  );
};

export default Section;